import React from "react";
import { useParams } from "react-router-dom";

import { PageMain } from "components/molecules";
import { useQuery } from "@tanstack/react-query";
import { userExamsApi } from "api/userExamsApi";
import { PaziaBreadcrumbs } from "components/atoms";
import { routes } from "consts";
import { ReviewExamProvider } from "./store/reducer";
import { RatingFromValues } from "./RatingPanelForm";
import { ExamPreview } from "./ExamPreview";
import { PaziaLoader } from "components/atoms";
import { QUERIES_KEYS } from "queries";

export const CourseUserExamPage = () => {
  return (
    <ReviewExamProvider>
      <Page />
    </ReviewExamProvider>
  );
};
const Page = () => {
  const { courseId, courseExamId, userId, userExamId } = useParams();
  const [openAnswer, setOpenAnswer] = React.useState(0);
  const { isLoading, data } = useQuery({
    queryKey: QUERIES_KEYS.USER_EXAM(Number(courseId), Number(courseExamId), Number(userId), Number(userExamId)),
    queryFn: () =>
      userExamsApi.fetchUserExam(Number(courseId), Number(courseExamId), Number(userId), Number(userExamId)),
  });

  if (!data?.data) return null;

  const onSubmit = async (formData: RatingFromValues) => {
    setOpenAnswer((pv) => pv + 1);
  };

  const { userExam, course } = data.data;
  if (isLoading) return <PaziaLoader position="center" />;

  return (
    <PageMain>
      <PaziaBreadcrumbs
        className="mb-4"
        segments={[
          { title: "Kursy", path: routes.COURSES },
          {
            title: [course.name, course.variant].filter(Boolean).join(" · "),
            path: routes.COURSES_MANAGE(courseId),
          },
          {
            title: "Wyniki egzaminów",
            path: routes.COURSES_MANAGE_NESTED.EXAMS(courseId, userExam.courseExamId),
          },
          {
            title: userExam.name,
          },
        ]}
      />
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 flex-grow rounded-sm border border-slate-200 bg-white p-4 shadow-lg dark:border-slate-700 dark:bg-slate-800">
          <div>{userExam.name}</div>
          <div>{userExam.description}</div>
          <span className="font-semibold">Wynik egzaminu: </span>
          <span>
            {!userExam.status ? <span className="text-orange-500">Nie oceniono</span> : examStatuses[userExam.status]}
          </span>
        </div>
        <ExamPreview
          userExam={userExam}
          openAnswer={openAnswer}
          onClick={(idx) => setOpenAnswer(idx)}
          setOpenAnswer={setOpenAnswer}
          onSubmit={onSubmit}
          courseId={Number(courseId)}
          courseExamId={Number(courseExamId)}
          userId={Number(userId)}
          userExamId={Number(userExamId)}
        />
      </div>
    </PageMain>
  );
};

const examStatuses: Record<number, React.ReactNode> = {
  1: <span className="text-emerald-500">Zaliczony pozytywnie</span>,
  2: <span className="text-rose-500">Nie zaliczony</span>,
};
